exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "fieldset[data-v-1d2809d2]{border:unset;border-radius:10px;border:thin groove threedface}legend[data-v-1d2809d2]{margin-left:10px;font-size:12px;width:unset}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1d2809d2","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/shared/InlineFieldset.vue
// module id = 1060
// module chunks = 0